import React, { useState } from "react";
import { useSelector } from "react-redux";
import useFillHistories from "../../hooks/common/useFillHistories";
import GamesItems from "../mui/games_items/GamesItems";

export default function HistoryGames() {
  const games = useSelector((state) => state.games.runningGames);
  const [loader, setLoader] = useState(true);

  useFillHistories(0, setLoader);

  return <GamesItems games={games} loader={loader} noGames />;
}
